import { Component, OnInit, DoCheck, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Widget } from '../../../models/form';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements OnInit {

  constructor() { }
  @Input() widget: Widget;
  @Input() formGroup: FormGroup;
  @Output() updateData = new EventEmitter();
  @Input() align: "inline" | "break" = "inline";

  ngOnInit() {
    console.log(this.widget);
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form/select-input/select-input.component.ts